module.exports = __webpack_public_path__ + "img/9.812c39a4.jpg";